<template>
	<page class="dashboard" title="Organisationer" style="background-color: #F0F0F0;">
		<input class="tool-text" placeholder="Søg" type="text" slot="tools" v-model="search" />
		<button-view style="float: left;" slot="tools" @click="createClient">+ Ny</button-view>
		<button-view style="float: left;" slot="tools" @click="migrateClient">&gt; Migrer</button-view>
		<new-table-view class="list" @itemClick="itemClick" :columns="[
			{
				label: 'Navn',
				name: 'label'
			},
			{
				label: '',
				name: 'delete',
				align: 'right',
				template: {
					name: 'button',
					label: 'Slet'
				},
				weight: '100px'
			}
		]" :items="_items" @context="itemContext" @delete="itemDelete" />
	</page>
</template>

<script>
	import { bus } from '../../bus'

	import ContextPopupView from '../views/ContextPopupView';

	const protocol = require('../../protocol');

	import client from '../model/client';
	import organisation from '../model/organisation';

    export default {
		data() {
			return {
				search: '',
				items: []
			};
		},
		components: {

		},
		watch: {

		},
		computed: {
			_items() {
				const self = this;

				return this.search == '' ? this.items : this.items.filter((item) => {
					const buffer = item.label.toLowerCase();
					return buffer.indexOf(self.search) > -1;
				});
			}
		},
		methods: {
			createClient() {
				const self = this;

				organisation.open(null, () => {
					self.update();
				});
			},
			migrateClient() {
				const self = this;

				organisation.openMigration(null, () => {
					self.update();
				});
			},
			async itemDelete(item, event) {
				event.stopPropagation();

				if (confirm('Sikker?')) {
					organisation.del(item.id);
					this.update();
				}
			},
			createAction(item, template) {
				const self = this;

				return {
					label: template.label,
					action: async function () {
						//window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						client.send({
							id: item.id,
							topic: `clients/${item.id}`,
							tmpl: template.tmpl
						}, async (model) => {
							await self.axios.post('/publish', {
								topic: model.topic,
								payload: model.tmpl
							});

							return true;
						});
					}
				};
			},
			itemContext(item, event) {
				event.stopPropagation();
				console.log('context', item);

				var actions = [];

				for (var i = 0; i < protocol.length; ++i) {
					console.log('prot', protocol[i]);
					actions.push(this.createAction(item, protocol[i]));
				}

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
			async itemClick(item) {
				const self = this;

				organisation.open(item.id, () => {
					self.update();
				});
			},
			async update() {
				this.items = (await this.axios.get('/organisations?_size=1000')).data.content;
			}
		},
		mounted() {
			this.update();

			var self = this;

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.tool-text {
		display: block;
		float: left;
		margin-left: 10px;
		height: 40px;
		border-radius: 20px;
		padding-left: 20px;
		border: 1px solid #cecece;
	}

	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		width: 100%;
		height: 100%;
		border-left: 1px solid #cecece;
		background-color: white;
	}
</style>